import { render, staticRenderFns } from "./KitView.vue?vue&type=template&id=f90cbb3e&scoped=true&"
import script from "./KitView.vue?vue&type=script&lang=ts&"
export * from "./KitView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90cbb3e",
  null
  
)

export default component.exports